/**
 * Песочница `console` для прикладного JS (`En.run`, client-import).
 * Нативный `window.console` webui не подменяем.
 *
 * Включение: `localStorage.setItem('debug_script_console', '1')`.
 */
export const PLATFORM_SCRIPT_CONSOLE_WINDOW_KEY = '__platformScriptConsole'
export const PLATFORM_SCRIPT_CONSOLE_STORAGE_KEY = 'debug_script_console'
export const PLATFORM_SCRIPT_CONSOLE_LOG_PREFIX = '[script]'

export const PLATFORM_SCRIPT_CONSOLE_PREAMBLE =
  `var console = window.${PLATFORM_SCRIPT_CONSOLE_WINDOW_KEY};\n`

const nativeConsole: Console = globalThis.console
const noop = (): void => {}

const PREFIX_METHODS = new Set(['log', 'info', 'warn', 'error', 'debug'])

type ScriptConsoleHost = Window & typeof globalThis & {
  [PLATFORM_SCRIPT_CONSOLE_WINDOW_KEY]?: Console
}

export function isPlatformScriptConsoleEnabled(): boolean {
  try {
    return localStorage.getItem(PLATFORM_SCRIPT_CONSOLE_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

function createPlatformScriptConsole(): Console {
  return new Proxy({} as Console, {
    get(_target, prop) {
      if (!isPlatformScriptConsoleEnabled()) {
        return noop
      }
      const value = Reflect.get(nativeConsole, prop, nativeConsole)
      if (typeof value !== 'function') {
        return value
      }
      if (typeof prop === 'string' && PREFIX_METHODS.has(prop)) {
        return value.bind(nativeConsole, PLATFORM_SCRIPT_CONSOLE_LOG_PREFIX)
      }
      return value.bind(nativeConsole)
    },
  })
}

export function installPlatformScriptConsole(
  target: ScriptConsoleHost = window as ScriptConsoleHost,
): Console {
  const existing = target[PLATFORM_SCRIPT_CONSOLE_WINDOW_KEY]
  if (existing) {
    return existing
  }
  const shim = createPlatformScriptConsole()
  target[PLATFORM_SCRIPT_CONSOLE_WINDOW_KEY] = shim
  return shim
}

if (typeof window !== 'undefined') {
  installPlatformScriptConsole()
}
